import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { ToastService } from 'src/app/core/toast/toast.service';
import { Session, Tokens, User } from 'src/app/features/login/login';
import { UserData } from 'src/app/model/user';
import { LocalStorageService } from 'src/app/services/local-storage.service';

import { UserService } from '../user.service';
import { CommonModule } from '@angular/common';
import { LoadingAnimationModule } from 'src/app/core/loading-animation/loading-animation.module';

@Component({
    selector: 'app-user-info',
    templateUrl: './user-info.component.html',
    imports:[CommonModule, LoadingAnimationModule],
    styleUrls: ['./user-info.component.scss'],

})
export class UserInfoComponent  implements OnInit, OnDestroy{

  public user?: User;


  ready: boolean = false;

  private theEnd$ = new Subject<void>();


  constructor(
    private userService: UserService,
    private localStorage: LocalStorageService,
    private toast: ToastService,
    private router: Router,
    private routerParam: ActivatedRoute,
  ) {
  
  }


  ngOnInit(): void {

    this.localStorage.setTitolo('Informazioni utente')

    this.userService.getCurrentUserProfile().pipe(takeUntil(this.theEnd$)).subscribe({
      next: (data: User) => {

        //this.userData = data;
        
        this.user = data;
        this.ready = true;

        //let i = this.myForm.parsedFields.findIndex(x=> x.name == 'phoneNumber');

        //this.getTheAcusList();
        //this.getTheFornitoriUserList();
        //this.getUserAnagrafiche();
      }
    });

  }

  // getUserAnagrafiche() {
  //   this.userService.getAnagraficheForUser(this.userData!.userId).pipe(takeUntil(this.theEnd$)).subscribe({
  //     next: (data: AnagraficheUserDataResponse) => {
  //       this.userAnagrafiche = data;
  //     },
  //     error: () => {

  //     }
  //   });
  // }

  ngOnDestroy(): void {
        this.theEnd$.next();
    this.theEnd$.complete();
  }



}
